export const Footer = () => {
  return <div id="footer">2021 INVEX® Todos los derechos reservados</div>;
};
